// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/vcsalc/" + chunkId + "." + {"5":"eefdfa8565c2a6b858ea","130":"36200313b9a94b204647","519":"14618f75e02bd295b722","608":"7998aa07e379b21127a1","752":"28144268c6f7910b107d","765":"6b2959163df31bd81b1e","766":"76da16b6755ee389f18d"}[chunkId] + ".js";
};